import { USER_ERRORS } from "../user/user-errors.js";

export const STAFF_ERRORS = {
	USER_NOT_FOUND: USER_ERRORS.NOT_FOUND,
	IMPERSONATION_LOG_NOT_FOUND: "impersonation_log_not_found",
	NOT_IMPERSONATING: "not_impersonating",
} as const;

export type StaffErrorCode = (typeof STAFF_ERRORS)[keyof typeof STAFF_ERRORS];
